import { db } from './firebaseConfig';
import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  deleteDoc, 
  serverTimestamp,
  query,
  orderBy
} from 'firebase/firestore';

// Letter Templates Service
export const letterTemplatesService = {
  // Create a new letter template
  async createTemplate(templateData) {
    try {
      const templatesRef = collection(db, 'letterTemplates');
      const docRef = await addDoc(templatesRef, {
        ...templateData,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
      return { id: docRef.id, ...templateData };
    } catch (error) {
      console.error('Error creating letter template:', error);
      throw error;
    }
  },

  // Get all letter templates
  async getAllTemplates() {
    try {
      const templatesRef = collection(db, 'letterTemplates');
      const q = query(templatesRef, orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error fetching letter templates:', error);
      throw error;
    }
  },

  // Update letter template
  async updateTemplate(templateId, updates) {
    try {
      const templateRef = doc(db, 'letterTemplates', templateId);
      await updateDoc(templateRef, {
        ...updates,
        updatedAt: serverTimestamp()
      });
      return { id: templateId, ...updates };
    } catch (error) {
      console.error('Error updating letter template:', error);
      throw error;
    }
  },

  // Delete letter template
  async deleteTemplate(templateId) {
    try {
      const templateRef = doc(db, 'letterTemplates', templateId);
      await deleteDoc(templateRef);
      return templateId;
    } catch (error) {
      console.error('Error deleting letter template:', error);
      throw error;
    }
  }
};

// Generated Letters Service
export const generatedLettersService = {
  // Save generated letter
  async saveGeneratedLetter(letterData) {
    try {
      const lettersRef = collection(db, 'generatedLetters');
      const docRef = await addDoc(lettersRef, {
        ...letterData,
        createdAt: serverTimestamp()
      });
      return { id: docRef.id, ...letterData };
    } catch (error) {
      console.error('Error saving generated letter:', error);
      throw error;
    }
  },

  // Get all generated letters
  async getAllGeneratedLetters() {
    try {
      const lettersRef = collection(db, 'generatedLetters');
      const q = query(lettersRef, orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error fetching generated letters:', error);
      throw error;
    }
  },

  // Delete generated letter
  async deleteGeneratedLetter(letterId) {
    try {
      const letterRef = doc(db, 'generatedLetters', letterId);
      await deleteDoc(letterRef);
      return letterId;
    } catch (error) {
      console.error('Error deleting generated letter:', error);
      throw error;
    }
  }
};

// Letter Generation Utility
export const letterGeneratorService = {
  // Extract placeholders from template content
  extractPlaceholders(content) {
    const placeholderRegex = /\{\{([^}]+)\}\}/g;
    const placeholders = [];
    let match;
    
    while ((match = placeholderRegex.exec(content)) !== null) {
      if (!placeholders.includes(match[1].trim())) {
        placeholders.push(match[1].trim());
      }
    }
    
    return placeholders;
  },

  // Fill template with data
  fillTemplate(templateContent, data) {
    let filledContent = templateContent;
    
    Object.keys(data).forEach(key => {
      const placeholder = `{{${key}}}`;
      const value = data[key] || '';
      filledContent = filledContent.replace(new RegExp(placeholder, 'g'), value);
    });
    
    return filledContent;
  },

  // Generate letter with template and data
  generateLetter(template, data) {
    const filledContent = this.fillTemplate(template.content, data);
    
    return {
      templateId: template.id,
      templateName: template.name,
      content: filledContent,
      originalTemplate: template.content,
      filledData: data,
      generatedAt: new Date().toISOString()
    };
  }
};